import { History } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { monthLabel, monthStr } from "@/lib/format";

export const MonthPicker = ({ month, setMonth }) => {
  const now = monthStr();
  return (
    <div className="flex items-center gap-2" data-testid="month-picker">
      <span className="text-[10px] font-bold uppercase tracking-wider text-muted-foreground">Month</span>
      <Input type="month" max={now} value={month} onChange={(e) => e.target.value && e.target.value <= now && setMonth(e.target.value)}
        className="h-9 w-40" data-testid="month-picker-input" />
      {month !== now && (
        <Button variant="outline" size="sm" onClick={() => setMonth(now)} data-testid="month-picker-current-btn">Current month</Button>
      )}
    </div>
  );
};

export const PastMonthBanner = ({ data }) => {
  if (!data || data.is_current) return null;
  return (
    <div className="mb-4 flex items-center gap-2 rounded-md border border-sky-200 bg-sky-50 px-4 py-2.5 text-sm text-sky-800" data-testid="past-month-banner">
      <History className="h-4 w-4 shrink-0" />
      Viewing closed month <b className="mx-1">{monthLabel(data.month)}</b> — stock figures are as of month-end and sales history is the 12 months before it.
    </div>
  );
};
